export default __webpack_public_path__ + "static/1d229a694787baefe1845b2656f80c43.png";